import React, { useState } from 'react';
import { Search, X } from 'lucide-react';

const PassagesPanel = ({
  filteredPassages,
  activePassageId,
  renderPassageContent,
  onPassageSelect,
  onSearch,
  isSearching,
  searchQuery = '',
  onSearchQueryChange,
  onResetSearch
}) => {
  // État pour afficher/masquer les détails de la recherche
  const [showSearchDetails, setShowSearchDetails] = useState(false);
  
  return (
    <div className="flex flex-col h-full">
      {/* En-tête du panneau avec titre et compteur */}
      <div className="p-3 border-b border-gray-200 flex items-center justify-between bg-white">
        <h3 className="text-sm font-medium">
          Passages <span className="text-gray-500">({filteredPassages.length})</span>
        </h3>
        
        <button
          onClick={() => setShowSearchDetails(!showSearchDetails)}
          className="p-1 text-gray-500 hover:bg-gray-100 rounded"
        >
          <Search className="h-4 w-4" />
        </button>
      </div>
      
      {/* Zone de recherche dépliable */}
      {showSearchDetails && (
        <div className="p-3 border-b border-gray-200 bg-gray-50">
          <form onSubmit={onSearch} className="relative">
            <input
              type="text"
              placeholder="Rechercher dans les passages..."
              className="w-full p-2 pr-8 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              value={searchQuery}
              onChange={(e) => onSearchQueryChange(e.target.value)}
              disabled={isSearching}
            />
            
            {searchQuery && (
              <button
                type="button"
                className="absolute right-8 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
                onClick={onResetSearch}
              >
                <X className="h-4 w-4" />
              </button>
            )}
            
            <button
              type="submit"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
              disabled={isSearching || !searchQuery.trim()}
            >
              <Search className="h-4 w-4" />
            </button>
          </form>
        </div>
      )}
      
      {/* Liste des passages - avec barre de défilement */}
      <div className="flex-grow overflow-y-auto p-3 space-y-3">
        {isSearching ? (
          <div className="flex justify-center items-center h-full text-gray-500">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mr-2"></div>
            Recherche en cours...
          </div>
        ) : filteredPassages.length === 0 ? (
          <div className="flex justify-center items-center h-full text-gray-500">
            Aucun passage trouvé
          </div>
        ) : (
          // Liste des passages avec rendu personnalisé - ici utilise renderPassageContent pour afficher les résumés
          filteredPassages.map((passage) => (
            <div 
              key={passage.id} 
              onClick={() => onPassageSelect(passage)}
              className="cursor-pointer"
            >
              {renderPassageContent(passage)}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default PassagesPanel;